module.exports = __webpack_public_path__ + "img/svg/background-about-us.59dd68f83ff8cbaa233cf05dff1523fb.svg";